import { render } from "./PlayerSwitcher.vue?vue&type=template&id=7e86f7a7&scoped=true"
import script from "./PlayerSwitcher.vue?vue&type=script&lang=js"
export * from "./PlayerSwitcher.vue?vue&type=script&lang=js"

import "./PlayerSwitcher.vue?vue&type=style&index=0&id=7e86f7a7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e86f7a7"]])

export default __exports__